import React from "react";

const Landing = ({ data }) => {
  console.log(data);
  return (
    <div className="mt-6 text-white">
      <p className="mb-2">{data?.date}</p>
      <div
        className="text-white text-lg"
        dangerouslySetInnerHTML={{ __html: data?.description }}
      />
    </div>
  );
};

export default Landing;
